import { Component, OnInit, OnDestroy } from '@angular/core';
import { landing_data } from '../json/landing-data';
import { FundraiserService, VariablesService, UtilService, SeoService, EventsService } from '../../../shared/services';
import { schema } from '../../objects/schema';
import { faqSchema } from '../../objects/schema-faq';
import { reviewSchema } from '../../objects/schema-review';

import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-medical-landing',
  templateUrl: './medical-landing.component.html',
  styleUrls: ['./medical-landing.component.scss']
})
export class MedicalLandingComponent implements OnInit, OnDestroy {

  data;
  campaginCount;
  metaData;
  tags;
  page;
  v2DesignRoutes = [
    'medical-fundraising',
    'memorial-fundraising',
    'cancer-crowdfunding',
    'help-children',
    'fundraising-for-education',
    'hospital',
    'animal-fundraising',
    'transplant-crowdfunding',
    'sports-crowdfunding'
  ];
  isMemorial;

  constructor(
    private fundraiserService: FundraiserService,
    private variablesService: VariablesService,
    private utilService: UtilService,
    public seoService: SeoService,
    public eventsService: EventsService,
    private actRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.page = this.actRoute.snapshot.params.cause;
    this.data = landing_data[this.page];
    this.isMemorial = this.page === 'memorial-fundraising' ? true : false;
    this.seoService.updateCanonicalURL(`/cause/${this.page === 'hospital' ? 'medical-fundraising' : this.page}`);
    this.variablesService.pageName = this.page === 'medical-fundraising' ? 'medical' : this.page;
    this.addMetaTags();
    this.variablesService.mainLayoutConfig.next({
      showHeader: true,
      showFooter: true,
      showMenus: true,
      showProfile: true,
      showSearch: true,
      logoNavigate: true,
      animateHeader: false,
      zendesk: true,
      headerTopSticky: false,
      showFooterSEO: this.showFooterSeo()
    });
    this.utilService.scrollToTop();
    this.getCampaignCount();

    // this.variablesService.pageName = this.page;
    if (this.utilService.isBrowser) {
      this.seoService.schemaBodyObject(schema, 'WebPageID');
      this.seoService.schemaOrgObject(faqSchema[this.page], 'FAQPageID');
      if (this.page.match('animal-fundraising|creative-fundraising|sports-crowdfunding|transplant-crowdfunding')) {
        this.seoService.schemaBodyObject(reviewSchema[this.page]);
      } else {
        this.seoService.schemaOrgObject(reviewSchema[this.page], 'ReviewPageID');
      }
    }
    this.sendPageViewEvent();
  }

  showFooterSeo(): boolean {
    return this.page.match('medical-fundraising|cancer-crowdfunding|fundraising-for-education|memorial-fundraising|help-children|animal-fundraising|transplant-crowdfunding|sports-crowdfunding');
  }

  addMetaTags() {
    this.metaData = {
      title: this.data.metaTitle,
      description: this.data.metaDesc,
      keywords: this.data.keywords ? this.data.keywords : 'medical crowdfunding, medical fundraising, ketto',
      image: `${environment.APP.DOMAIN_URL}/assets/images/causes/${this.page}.png`,
      url: `${environment.APP.DOMAIN_URL}/cause/${this.page}`,
      site: 'Ketto.org'
    };
    if (this.page === 'hospital') {
      this.metaData['robots'] = 'noindex, follow';
    }
    this.tags = this.seoService.createTagObject(this.metaData);
    this.seoService.addMetaTags(this.tags);
    this.utilService.setPageTitle(this.data.metaTitle);
  }



  checkV2Design() {
    return this.v2DesignRoutes.includes(this.page);
  }

  getCampaignCount() {
    this.fundraiserService.getCampaignCount().subscribe((res: any) => {
      this.variablesService.campaignCount = res.data;
    });
  }

  sendPageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView',
      event_type: 'campaign',
      page_name: this.variablesService.pageName,
      referrer_page: this.utilService.getReferrer()
    };
    this.eventsService.onLoadSystemEvent(pageViewPayload);
  }

  ngOnDestroy() {
  }

}
